import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";
import VideoPlayer from "../../components/VideoPlayer";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Our team appears in the media: press and television"}
                    description={"Our lawyers publish regularly, including in the press. In various radio and television programs, they provide interpretation and explanations, always within the framework of the mandate granted by the client. This page references the most important content."}
                    url={"https://www.coeladvocaten.be/en/press"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/pers", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/presse", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/press", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/pers"
                    switchUrlFR="/fr/presse"
                />
                
                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-press"></div>
                        <div className="slider">
                            <h1>Press</h1>
                            <h2>Coel Advocaten</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            {/* <!-- 1 --> */}
                            <div id="1"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/8.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Somers' party colleague leads protest against Schuttersvest parking</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Een gerechtsdeurwaarder heeft vrijdagmorgen aan de burgemeester 637 bezwaarschriften overhandigd tegen de nieuwe parking Schuttersvest.</p>
                                        <a className="button" target="_blank" href="https://www.gva.be/cnt/aid1029107/partijgenoot-somers-leidt-protest-parking-schuttersvest">Read more</a> 
                                    </div>
                                </div>
                            </div>   

                            {/* <!-- 2 --> */}
                            <div id="2"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/10.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Soil pollution can stop Schuttersvest parking construction</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Het actiecomité dat de bouw van de ondergrondse parking aan de Schuttersvest wil voorkomen, overhandigde burgemeester Bart Somers gisterochtend voor het schepencollege een lijvig dossier dat alle bezwaren bundelt.</p>
                                        <a className="button" target="_blank" href="https://www.nieuwsblad.be/cnt/kb37pfte">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 3 --> */}
                            <div id="3"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/7.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Arson committed to avenge sister Olga</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Wraak. Met die drijfveer heeft Stacy De Coster (30) uit Haacht vorige week brand gesticht bij G.V. Die 66-jarige man uit Rijmenam misbruikte Stacy’s zus Olga twintig jaar geleden. Ook in het onderzoek naar haar dood - in februari werd het lichaam van Olga De Coster in het kanaal in Vilvoorde gevonden - werd het huis van G.V. doorzocht. Stacy knapte, en trok op oorlogspad.</p>
                                        <a className="button" target="_blank" href="https://www.hln.be/in-de-buurt/vilvoorde/brand-gesticht-om-zus-olga-te-wreken~af448d8f/">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 4 --> */}
                            <div id="4"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/9.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Undocumented child (10) without family in police cell</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Een Armeens jongetje uit Mechelen heeft dinsdag de hele dag alleen in een Lierse politiecel gezeten nadat was gebleken dat hij illegaal in het land is. Zijn grootvader, met wie hij samen naar het politiekantoor was gebracht als getuige in een gerechtelijk dossier, moest naar huis vertrekken.</p>
                                        <a className="button" target="_blank" href="https://www.gva.be/cnt/dmf20150825_01834451/illegaal-kind-10-zonder-familie-in-politiecel">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 5 --> */}
                            <div id="5"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/2.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Kucam case is based on rumors</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Het Mechelse N-VA-gemeenteraadslid Melikan Kucam blijft voorlopig aangehouden. Dat heeft de raadkamer in Antwerpen vanochtend beslist. Kucam werd een week geleden opgepakt. Hij zou via tussenpersonen voor tienduizenden euro humanitaire visa verkocht hebben.</p>
                                        <a className="button" target="_blank" href="https://atv.be/nieuws/video-dossier-kucam-is-gebaseerd-op-geruchten-72263">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 6 --> */}
                            <div id="6"></div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/1.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>A certain Frank, from parliament, organizes visas for payment</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Het Mechelse gemeenteraadslid Melikan Kucam blijft voorlopig in de gevangenis. Dat heeft de raadkamer van Antwerpen vanmorgen beslist. Advocaat Frank Coel, die Kucam verdedigt, blijft erbij dat zijn cliënt geen geld heeft gekregen, noch mensen geld heeft afgeperst voor het uitreiken van humanitaire visa.</p>
                                        <a className="button" target="_blank" href="https://www.pzc.nl/antwerpen/ne-zekere-frank-in-parlement-regelt-tegen-betaling-visa~a4be3dc9">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 7 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/4.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Melikan Kucam appeals confirmation of his arrest</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Melikan Kucam (44) gaat in beroep tegen de bevestiging van zijn aanhouding door de raadkamer in Antwerpen. Dat zegt his lawyer Frank Coel. Hij zal nu binnen de vijftien dagen voor de Antwerpse kamer van inbeschuldigingstelling verschijnen.</p>
                                        <a className="button" target="_blank" href="https://www.hln.be/nieuws/binnenland/melikan-kucam-gaat-in-beroep-tegen-bevestiging-van-aanhouding~a2fdd8b4">Read more</a> 
                                    </div>
                                </div>
                            </div>    

                            {/* <!-- 8 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/6.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Belgian councillor arrested for selling humanitarian visa</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>A Belgian city councillor has been arrested on suspicion of selling humanitarian visas to refugees, the public prosecutor's office in Antwerp has said.
                                           <br />Melikan Kucam, who is a member of Belgium's nationalist party, the Flemish National Alliance (N-VA), is said to have charged refugees up to €20,000 in exchange for the visa in Belgium.
                                           He has been charged with trafficking, corruption and extortion.</p>
                                        <a className="button" target="_blank" href="https://www.euronews.com/2019/01/17/belgian-councillor-arrested-on-suspicion-of-selling-humanitarian-visas">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Video1 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <VideoPlayer id="XnYu8Fby_hQ"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>RTV. Debate on political issues elections 2019</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Asylum and follow-up migration</p>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Video2 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <VideoPlayer id="CQ0XWTFsAoE"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>RTV. News</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Interview regarding Melikam Kucam</p>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Video3 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <VideoPlayer id="BznCJG2Pa8Q"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>RTL TVI. It's not every day Sunday</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Interview with Christophe Deborsu regarding the Kucam case and the visa crisis</p>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Video4 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <VideoPlayer id="Ffi8wvB4fn8"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>VRT. The seventh day</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Interview with Lisbeth Imbo regarding the Kucam case and the visa crisis</p>
                                    </div>
                                </div>
                            </div>


                    
                            {/* <!-- 9 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/5.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>The lawyer denies that Melikan Kucam committed benefit fraud in addition to visa fraud: "my client is bewildered"</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>De advocaat van Mechels N-VA-gemeenteraadslid Melikan Kucam ontkent alle aantijgingen over uitkeringsfraude. Zowel De Morgen als Het Laatste Nieuws schreven vrijdag dat speurders van de federale politie bekijken of Kucam voor de Syriërs en Irakezen die hij naar hier haalde ook uitkeringsfraude pleegde. Zijn advocaat Frank Coel ontkende dat in een reactie in De Ochtend op Radio 1 ten stelligste.</p>
                                        <a className="button" target="_blank" href="https://www.gva.be/cnt/dmf20190118_04112282/advocaat-ontkent-dat-melikan-kucam-naast-fraude-met-visa-ook-uitkeringsfraude-pleegde-mijn-client-is-verbijsterd">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 10 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/3.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Migration lawyer: "we encounter painful cases"</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>De procedures om asielzoekers te erkennen gaan de laatste tijd sneller. Dat zegt Frank Coel. Coel was tot 2012 provincieraadslid voor Open VLD, maar hij is ook een advocaat die gespecialiseerd is in vluchtelingen- en migratierecht. Migratie wordt bij de komende verkezingen een van de belangrijkste thema's. Volgens sommigen is ons land te streng met zijn erkenningsprocedures. Maar de cijfers lijken dat tegen te spreken. België erkent meer vluchtelingen dan gemideld in de Europese Unie.</p>
                                        <a className="button" target="_blank" href="https://www.rtv.be/artikels/advocaat-migratierecht-wij-komen-schrijnende-gevallen-tegen-a68361">Read more</a> 
                                    </div>
                                </div>
                            </div>

                            {/* <!-- 11 --> */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <img src="/static/images/pers/11.jpg" alt="post img" className="img-fluid img-responsive" width="330px" height="300px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p></p>
                                        <h3>Frank Coel</h3>
                                    </div>
                                </div>
                            </div> 

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <p>Press articles about Frank</p>
                                        <a className="button" target="_blank" href="https://www.demorgen.be/tag/frank-coel">Read more</a> 
                                    </div>
                                </div>
                            </div>                      
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
